module.exports = __webpack_public_path__ + "static/media/bx3.28f07459.png";